/**
 * Direktlink-Schnellspur.
 *
 * Wird TaskDash direkt mit `#/order/<uid>` geöffnet (z. B. aus Quelp), soll die
 * Bestellung innerhalb weniger Sekunden stehen. Firestore liefert den ersten
 * Snapshot eines kleinen Listeners aber erst, wenn ALLE gleichzeitig offenen
 * Listener ihren Erstbestand übertragen haben (ein Watch-Stream, gemeinsamer
 * konsistenter Snapshot). Die Bestellung wartete bisher hinter ~400 Tickets,
 * 300 Checklist-Einträgen, Ratings und Edit-Jobs.
 *
 * Darum starten die Hintergrund-Listener (loadData, Header-Checkliste,
 * Header-Edits) bei einem Direktlink erst, wenn OrderView seinen ersten
 * Snapshot hat — oder nach spätestens 6 s als Sicherheitsnetz. Ohne Direktlink
 * ist `ready` sofort erfüllt, es ändert sich nichts.
 */
const isDeepLink = /^#\/order\/[^/?#]+/.test(window.location.hash);

let release = () => {};
const ready = new Promise((resolve) => {
  release = resolve;
});

if (!isDeepLink) release();
else setTimeout(release, 6000);

export const bootLane = {
  isDeepLink,
  /** Promise — erfüllt, sobald Hintergrund-Listener starten dürfen */
  ready,
  /** Von OrderView nach dem ersten Snapshot (oder Fehler) aufgerufen */
  release: () => release(),
};
